import { Link, useLocation } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const location = useLocation();

  return (
    <nav aria-label="面包屑导航" className="max-w-[1400px] mx-auto px-4 md:px-6 py-3">
      <ol className="flex items-center gap-1.5 text-xs text-foreground-500 flex-wrap">
        <li>
          <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1.5">
            <span className="text-foreground-300">/</span>
            {item.path && index < items.length - 1 ? (
              <Link to={item.path} className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className={index === items.length - 1 ? "text-foreground-800 font-medium" : ""}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}